import { useMutation, UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import * as feedbackApi from "js/api/feedbackApi";

export const useSubmitFeedbackMutation = (
	options?: UseMutationOptions<undefined, unknown, feedbackApi.SubmitFeedbackRequest>
): UseMutationResult<undefined, unknown, feedbackApi.SubmitFeedbackRequest> => {
	const mutation = useMutation({
		mutationFn: (data: feedbackApi.SubmitFeedbackRequest) => feedbackApi.submitFeedback(data),
		...options,
	});
	return mutation;
};
